import pathlib from 'path';

export default function formattedImgPath (path, dim, fileExt) {
  let extName = pathlib.extname(path);
  let baseName = pathlib.basename(path, extName);
  let sizeName;
  if ('width' in dim) {
    sizeName = `w${dim.width}`;
  } else if ('height' in dim) {
    sizeName = `h${dim.height}`;
  } else {
    throw new Error(`Invalid dimension object: ${dim}`);
  }
  return `${pathlib.dirname(path).replace('/content/', '/generated/')}/${baseName}-${sizeName}.${fileExt}`;
}



// WEBPACK FOOTER //
// ./lib/rlink-repos/formattedImgPath.js